import { useRef, useMemo } from 'react';
import { toast } from 'sonner';
import { useSocketEvents } from './useSocketEvents';
import { playVoiceAlert } from '../utils/voiceAlert';

/** Bildirishnoma, navbat, buyurtma holati — bitta umumiy socket orqali */
export function useOrderSocket({ onRefresh, onGeofence } = {}) {
  const onRefreshRef = useRef(onRefresh);
  const onGeofenceRef = useRef(onGeofence);
  onRefreshRef.current = onRefresh;
  onGeofenceRef.current = onGeofence;

  const handlers = useMemo(
    () => ({
      notification: (payload) => {
        const title = payload?.title || 'SmartGaz';
        const body = payload?.body || payload?.message || '';
        if (payload?.meta?.type === 'GEOFENCE_ENTER') {
          playVoiceAlert('Diqqat! Gaz mashinasi sizning mahallangizga yaqinlashmoqda.');
          toast.info(`${title}: ${body}`, { duration: 8000 });
          onGeofenceRef.current?.(payload);
          onRefreshRef.current?.();
        } else {
          toast.message(title, { description: body });
          onRefreshRef.current?.();
        }
      },
      order_update: () => onRefreshRef.current?.(),
      order_status_changed: () => onRefreshRef.current?.(),
      queue_update: () => onRefreshRef.current?.(),
    }),
    [],
  );

  useSocketEvents(handlers);
}
